<template>
  <ListRelatorio tipo="2"></ListRelatorio>
</template>
<script>
import ListRelatorio from "./List.vue";

export default {
  components: {
    ListRelatorio
  }
};
</script>